import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import declare from "dojo/_base/declare";
import { C8Node } from "src/c8-platform/type/node";
import MatrixWidget from "src/SpecificationDataSheet/SharedSectionItemMapMatrix";
import AllComponentsTable from "./AllComponentsTable";

export = declare(MatrixWidget, {
	/**
	 * @override
	 * do nothing here, the table would do the additional query so that both spec section matrix and spec item matrix  would be served
	 */
	addDeferred(ctx: Context, h: Heading, dfds: PromiseLike<any>[]) {

	},

	/**
	 * @override
	 * get the sorted column nodes
	 */
	_getColumnNodes(ctx: Context, h: Heading): C8Node[] | undefined {
		const view = ctx.view as unknown as typeof AllComponentsTable.prototype;

		return view.specItemsAcrossComponent;
	},
});